module.exports = __webpack_public_path__ + "static/img/Frame602.c5cbfb19.png";